import { useState } from "react";
import ModalLayout from "../../../components/Layout/ModalLayout";
import AddSubscriptionPayment from "./AddSubscriptionPayment";
import { Link } from "react-router-dom";
import SubscriptionPay from "./SubscriptionPay";

const SubscriptionExpiredShow = () => {
	return (
		<div className="bg-danger py-3">
			<div className="container text-white d-flex justify-content-center align-items-center gap-3">
				<h1 className="text-center">
					Your Subscription is Expired. Please Renew Your Subscription.
				</h1>
				<div className="d-flex justify-content-center gap-3">
					<Link to="/dashboard/subscriptions/payment-invoice">
						<button type="button" className="btn btn-warning">
							Show Invoice
						</button>
					</Link>

					<SubscriptionPay />
				</div>
			</div>
		</div>
	);
};

export default SubscriptionExpiredShow;
